UADeleteUsersCtrl.$inject = ['users', 'adminApi', '$uibModalInstance']
export default function UADeleteUsersCtrl(users, adminApi, $modalInstance) {
  this.users = users

  this.showError = false
  this.errorMessage = ''
  this.deleting = false
  this.deleteSummary = []

  this.deleteUsers = function() {
    if (confirm('Are you absolutely sure you want to do this??')) {
      this.deleting = true
      this.showError = false
      var uuids = this.users.map(function(u) {
        return u.uuid
      })
      adminApi.deleteUsers(uuids, {}).then(
        function(response) {
          this.deleteSummary = response
          this.deleting = false
        }.bind(this),
        function(reason) {
          this.showError = true
          this.errorMessage = reason
          this.deleting = false
        }.bind(this)
      )
    } else {
      $modalInstance.dismiss()
    }
  }
}
